import * as React from 'react'

import ModuleCard from './ModuleCard'
import IconType from '../../atoms/Icon/iconTypes'
import { colors } from '@lmc/common/constants'

type Props = {
  onClick?: () => void
}

export const FamilyPlanModuleCard = ({ onClick }: Props) => (
  <ModuleCard
    backgroundColor={colors.orange}
    icon={IconType.FamilyHexagon}
    link="/settings/family-settings"
    linkText="Find out more"
    onClick={onClick}
    subtitle="Keep relatives updated about their loved one’s care, wellbeing and health."
    title="Family Portal"
  />
)
